import React, { useEffect } from 'react';
import Map from '../Map';
import Footer from '../containers/Footer/Footer';

const Events = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={{ background: 'var(--ck-bg, #0d0d0d)' }}>
      <Map />
      <Footer />
    </div>
  );
};

export default Events;
